<template>
  <div class="card">
    <a name="improve"></a>
    <div class="card-header">
      <div class="card-header-title">
        <h4 class="title is-4">
          <i class="fas fa-wrench"></i>&nbsp;Improve a translation
        </h4>
      </div>
    </div>
    <div class="card-content">
      <div class="content">
        Most of the translations of this web app are made by users like yourself.
        Others have been made by machines. Regardless of source, these translations
        can be improved!
      </div>
    </div>
  </div>
</template>
